module.exports = __webpack_public_path__ + "img/firma_template3.0fb0cea.svg";